import { Menu } from '@mantine/core';
import { ChevronDownIcon } from '@heroicons/react/24/outline';

import { useGetLanguageInfo } from '@mygpt/app';

type LanguageSelectorProps = {
  variant?: 'button' | 'plain';
};

const LanguageSelector = ({ variant = 'button' }: LanguageSelectorProps) => {
  const { languageOptions, langSelected, languageOnChange } = useGetLanguageInfo();
  const buttonLabel = langSelected?.label ?? 'Language';

  if (variant !== 'button' || languageOptions.length <= 1) {
    return <span className="text-sm font-medium text-gray-600">{buttonLabel}</span>;
  }

  return (
    <Menu shadow="md" position="bottom-end" withinPortal>
      <Menu.Target>
        <button
          type="button"
          className="inline-flex items-center gap-2 rounded-lg border border-gray-200 bg-white px-3 py-2 text-sm font-medium text-gray-700 shadow-sm transition hover:border-gray-300 hover:text-gray-900 focus:outline-none focus-visible:ring-2 focus-visible:ring-primary-500"
        >
          {buttonLabel}
          <ChevronDownIcon className="h-4 w-4 text-gray-400" />
        </button>
      </Menu.Target>

      <Menu.Dropdown className="min-w-[140px]">
        {languageOptions.map((option) => (
          <Menu.Item
            key={option.value}
            onClick={() => languageOnChange(option.value)}
            className={option.value === langSelected?.value ? 'text-primary-600' : undefined}
          >
            {option.label}
          </Menu.Item>
        ))}
      </Menu.Dropdown>
    </Menu>
  );
};

export default LanguageSelector;
